// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"36d36c1f","604":"5a281ad3","697":"8bf64bec","782":"f2b3c407","923":"0f3bd801"}[chunkId] + ".chunk.js";
};